module.exports = __webpack_public_path__ + "media/images/homes/QuickBooksOnline-7f1a03f5ca5c21dce5e902d3a8ff4056.png";